import React from 'react';
import banner from './img/courses-bannner.png'
import './ciscoPage.css';
import CareerForm from './careerform';
import Footer from '../Components/footer'

const ciscoPage = () => {
  return (
    <div className='cisco-container'>
       <div className='cisco-banner-box'>
                  <div className='cisco-banner'>
        <img src={banner} alt=''/>
                  </div>
                </div>

<div className='detail-box'>
    <div className='cisco-heading'>
        <h1>Cisco Certification Course </h1>
        <p>The CCNA is designed to test your understanding of basic networking principles that are frequently encountered in IT network management roles. The Cisco Certified Network Associate certificate is a vendor-neutral IT certification that qualifies professionals in network administration.</p>
        </div> 
        <div className='carrer-section'>
        <div className='skills-section'>
<h2>🛡️ Top Cisco Certification Skills You’ll Master</h2>
<div className='skills-name'>
<span>Network fundamentals (OSI & TCP/IP models)</span>
<span>IPv4/IPv6 addressing and subnetting</span>
</div>
<div className='skills-name'>
  <span>Routing and switching concepts</span>
  <span>VLANs, NAT, DHCP, DNS</span>
</div>
<div className='skills-name'>
<span>Network security fundamentals</span>
</div>

        </div>
        <div className='job-roles'>
           <h1>💼 JOB ROLES AFTER COURSE</h1>
           <div className='job-name'>
            <span>Network Engineer</span>
            <span>Network Administrator</span>
            </div>
             <div className='job-name'>
            <span>Network Security Specialist</span>
            <span>System Engineer</span>
            </div>
             <div className='job-name'>
            <span>IT Support Engineer</span>
           </div>
        </div>
        </div>
        <div className='course-discription'>
            <h1>About this Course</h1>
<p>Cisco certifications validate the knowledge and skills IT professionals need to be successful at managing and maintaining Cisco technologies. This CBT Nuggets certification guide covers Cisco certifications, including how to earn Cisco certifications and the roles Cisco certifications can prepare learners for. Cisco has a robust certification program that validates whether IT professionals can manage, configure, and maintain Cisco equipment. Cisco certifications are designed to validate the knowledge that IT professionals have learned through on-the-job experience. In sum, networking professionals learn Cisco systems and networking through the normal course of their jobs. Cisco certifications then test that they learned the career-level appropriate knowledge and skills.
</p>
        </div>
         </div>
        <div className='join-container'>
        <div className='join-box'>
<div className='join-div'>
<h1>Who Should Join This Cisco Certification Course</h1>
<p><span> ✔ </span>Students who want to start a strong career in networking & IT.</p>
<p><span> ✔ </span>Freshers ready to enter the tech world with globally valued skills.</p>
<p><span> ✔ </span>Beginners who want to learn networking in a simple, practical way.</p>
<p><span> ✔ </span>Tech learners aiming to build real-world skills in network setup & management.</p>
<p><span> ✔ </span>IT beginners looking for a clear path to job-ready knowledge.</p>
<p><span> ✔ </span>Working professionals planning to upgrade into better IT roles.</p>
<p><span> ✔ </span>Support engineers who want to grow into networking specialists.</p>
<p><span> ✔ </span>Freelancers ready to offer network support and setup services.</p>
<p><span> ✔ </span>Self-learners searching for a structured and easy learning journey.</p>
<p><span> ✔ </span>Anyone who wants a secure, high-growth and future-ready career in IT.</p>

</div>
        </div>

                <CareerForm/>
        </div>

    <div className="modules-container">

      {/* Heading */}
      <h1 className="module">Course RoadMap</h1>
      <p className="subtitle">
        Step-by-step modules to master Cisco Certificate 
      </p>

      {/* Grid */}
      <div className="modules-grid">

        {/* Card 1 */}
        <div className="module-card">
          <div className="circle">01</div>
          <h3>Cisco Certification Overview</h3>
          <p>
            Understand Cisco certification paths, exam structure, and networking career opportunities.
          </p>
        </div>

        {/* Card 2 */}
        <div className="module-card">
          <div className="circle">02</div>
          <h3>Network Access</h3>
          <p>
           Learn switching, VLANs, trunking, and secure network access configurations.
          </p>
        </div>

        {/* Card 3 */}
        <div className="module-card">
          <div className="circle">03</div>
          <h3>IP Connectivity</h3>
          <p>
           Understand routing concepts, IP forwarding, and basic OSPF configuration.
          </p>
        </div>

        {/* Card 4 */}
        <div className="module-card">
          <div className="circle">04</div>
          <h3>IP Services</h3>
          <p>
          Explore NAT, DHCP, DNS, and network service configuration essentials.
          </p>
        </div>

        {/* Card 5 */}
        <div className="module-card">
          <div className="circle">05</div>
          <h3>Security Fundamentals</h3>
          <p>
           Implement basic network security, ACLs, device hardening, and threat prevention.
          </p>
        </div>

        {/* Card 6 */}
        <div className="module-card">
          <div className="circle">06</div>
          <h3>Automation & Programmability</h3>
          <p>
          Learn network automation basics, APIs, and software-defined networking concepts.
          </p>
        </div>

      </div>

        {/* Grid */}
      <div className="modules-grid">

        {/* Card 7 */}
        <div className="module-card">
          <div className="circle">07</div>
          <h3>Routing Technologies</h3>
          <p>
          Configure static and dynamic routing protocols for efficient data transmission.
          </p>
        </div>

        {/* Card 8 */}
        <div className="module-card">
          <div className="circle">08</div>
          <h3>Switching Technologies</h3>
          <p>
            Understand MAC tables, switching logic, and Layer 2 network operations.
          </p>
        </div>

        {/* Card 9 */}
        <div className="module-card">
          <div className="circle">09</div>
          <h3>WAN & Cloud Services</h3>
          <p>
           Explore WAN technologies, VPN basics, and cloud networking fundamentals.
          </p>
        </div>

        {/* Card 10 */}
        <div className="module-card">
          <div className="circle">10</div>
          <h3>Wireless Networking (Cisco)</h3>
          <p>
           Learn wireless standards, configurations, and secure enterprise Wi-Fi deployment.
          </p>
        </div>

        {/* Card 11 */}
        <div className="module-card">
          <div className="circle">11</div>
          <h3>Network Troubleshooting</h3>
          <p>
          Develop skills to diagnose, analyze, and resolve common network issues.
          </p>
        </div>

        {/* Card 12 */}
        <div className="module-card">
          <div className="circle">12</div>
          <h3>Practical Cisco Labs</h3>
          <p>
          Hands-on practice with Cisco devices using Packet Tracer and real scenarios.
Cisco certificate
          </p>
        </div>

      </div>
    </div>
  

<div>
        <Footer/>
</div>
    </div>
  )
}

export default ciscoPage
